<template>
  <section>
    <gs-header title="Quản lý mã giảm giá">
      <router-link :to="{ name: 'create-promotion' }" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm
        mới</router-link>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="promotionTable" :table-name="promotionTable" data-source="promotions" :data-params="filters"
        :data-sorted="sorted" :data-sorts="sorts" @remove-filter="removeFilter">
        <section slot="filters">

        </section>
        <template slot-scope="datas">
          <el-table :data="datas.data" border :row-class-name="tableRowClassName" style="width: 100%">
            >
            <el-table-column label="#" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[promotionTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[promotionTable].current_page - 1) *
                  dataPaginations[promotionTable].per_page)}}</small>
              </template>
            </el-table-column>

            <!-- <el-table-column
              label="Tỉnh thành"
              width="100"
            >
              <template slot-scope="scope">
                <p><span class="shipment-code-display">{{scope.row.id}}</span></p>
              </template>
            </el-table-column> -->

            <el-table-column label="Mã giảm giá">
              <template slot-scope="scope">
                <p><span class="shipment-code-display">{{ scope.row.code }}</span></p>
                <p>Ngày tạo: {{ scope.row.created_at }}</p>
                <p v-if="promotionHelpers.sources">Nguồn: <span
                    class="ui label blue">{{ promotionHelpers.sources[scope.row.source] }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="Phạm vi áp dụng">
              <template slot-scope="scope">
                <p>HVC: {{ scope.row.carrier_name }}</p>
                <p>Gửi từ: {{ scope.row.city_from_name }}</p>
                <p>Gửi đến: {{ scope.row.city_to_name }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Thời gian áp dụng">
              <template slot-scope="scope">
                <p>Từ ngày: {{ scope.row.start_date }}</p>
                <p>Đến ngày: {{ scope.row.end_date }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Giảm giá">
              <template slot-scope="scope">
                <p><span class="text-red">{{ scope.row.discount | number }} {{ scope.row.currency }}</span></p>
                <p>Giảm tối đa: <span class="text-red">{{ scope.row.max_discount | vnd }}</span></p>
                <p>Số lượng: <span class="text-red">{{ scope.row.quantity | number }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="Trạng thái">
              <template slot-scope="scope">
                <p><span class="ui label"
                    :class="[{ 'red': !scope.row.is_active }, { 'green': scope.row.is_active }]">{{ scope.row.status }}</span>
                </p>
                <p>Kiểu áp dụng: {{ scope.row.type }}</p>
                <p>Số lượng áp dụng cho từng user: {{ scope.row.quantity_per_user | number }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Số đơn">
              <template slot-scope="scope">
                <p>{{ scope.row.total_shipment | number }}</p>
              </template>
            </el-table-column>


            <el-table-column width="95">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <!-- <el-tooltip placement="top" content="Chi tiết" class="display-inline" v-if="!scope.row.deleted_at">
                    <a class="text-blue padding-all display-inline-block cursor-pointer" @click.prevent="detailPromotion(scope.row)"><i class="fa fa-search"></i></a>
                  </el-tooltip> -->
                  <el-tooltip placement="top" content="Sửa" class="display-inline" v-if="!scope.row.deleted_at">
                    <router-link class="text-orange padding-all display-inline-block cursor-pointer"
                      :to="{ name: 'edit-promotion', params: { id: scope.row.id } }"><i class="fa fa-pencil-square-o"
                        aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xóa" class="display-inline" v-if="!scope.row.deleted_at">
                    <a @click.prevent="deletePromotion(scope.row)"
                      class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Khôi phục" class="display-inline" v-if="scope.row.deleted_at">
                    <a class="text-blue padding-all display-inline-block cursor-pointer" @click="restore(scope.row)"><i
                        class="fa fa-refresh" aria-hidden="true"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
    </div>
  </section>
</template>

<script type="text/javascript">
import ls from 'local-storage'
import { debounce } from 'lodash'
import { deletePromotions, restorePromotions } from 'src/api/promotion'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Promotion',
  data() {
    return {
      promotionTable: 'promotions',
      filters: {
        sort: 'created_at:-1'
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' }
      ]
    }
  },
  computed: {
    ...mapGetters('promotion', ['promotion', 'promotionHelpers'])
  },
  methods: {
    ...mapActions('promotion', ['setPromotion', 'getPromotionHelpers']),
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.promotionTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.promotionTable)
      }
    }, 300),
    removeFilter() {
      if (!this.checkDefaultFilter({
        sort: 'created_at:-1'
      })) {
        this.reloadGsTable(this.promotionTable)
      }
      this.filters = {
        sort: 'created_at:-1'
      }
    },
    tableRowClassName(row) {
      if (row.deleted_at) {
        return 'row-orange'
      }
      return null
    },
    deletePromotion(promotion) {
      this.setPromotion(promotion)
      this.$confirm(`Bạn chắc chắn muốn xóa mã giảm giá ${this.promotion.code}`, 'Xóa mã giảm giá', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        deletePromotions(this.promotion.id).then(response => {
          if (response.code === 200) {
            this.$message({
              type: 'success',
              message: 'Xóa mã giảm giá thành công'
            })
            this.reloadGsTable(this.promotionTable)
          } else {
            this.$message({
              type: 'danger',
              message: 'Xóa mã giảm giá thất bại'
            })
          }
        })
      }).catch(() => {

      })
    },
    restore(promotion) {
      this.setPromotion(promotion)
      this.$confirm(`Bạn chắc chắn muốn khôi phục mã giảm giá ${this.promotion.code}`, 'Khôi phục mã giảm giá', {
        confirmButtonText: 'Khôi phục',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        restorePromotions(this.promotion.id).then(response => {
          if (response.code === 200) {
            this.$message({
              type: 'success',
              message: 'Khôi phục mã giảm giá thành công'
            })
            this.reloadGsTable(this.promotionTable)
          } else {
            this.$message({
              type: 'danger',
              message: 'Khôi phục mã giảm giá thất bại'
            })
          }
        })
      }).catch(() => {

      })
    }
  },
  mounted() {
    if (!Object.keys(this.promotionHelpers).length) {
      this.getPromotionHelpers()
    }
    if (ls.get('filters') && ls.get('filters')[this.promotionTable]) {
      this.filters = ls.get('filters')[this.promotionTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.promotionTable)
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['promotions']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>



// WEBPACK FOOTER //
// Promotion.vue?02867a9b